import { DropDownPosition } from './DropDownMenu';
const getPosition = (position, areaRequired, itemLeftPos, itemRightPos) => {
    let finalPosition = position;
    switch (position) {
        case DropDownPosition.LEFT:
            if (itemLeftPos > areaRequired / 2 && areaRequired / 2 < itemRightPos) {
                finalPosition = DropDownPosition.CENTER;
            }
            else if (itemLeftPos < areaRequired) {
                finalPosition = DropDownPosition.RIGHT;
            }
            break;
        case DropDownPosition.RIGHT:
            if (itemRightPos > areaRequired / 2 && areaRequired / 2 < itemLeftPos) {
                finalPosition = DropDownPosition.CENTER;
            }
            else if (itemRightPos < areaRequired) {
                finalPosition = DropDownPosition.LEFT;
            }
            break;
        case DropDownPosition.CENTER:
        default:
            if (itemLeftPos > areaRequired / 2 && areaRequired / 2 < itemRightPos) {
                finalPosition = DropDownPosition.CENTER;
            }
            else if (itemLeftPos < areaRequired) {
                finalPosition = DropDownPosition.RIGHT;
            }
            else if (itemRightPos < areaRequired) {
                finalPosition = DropDownPosition.LEFT;
            }
            break;
    }
    return finalPosition;
};
const identifyPosition = (boxRect, position, minPadding, itemWidth) => {
    const screenWidth = document && document.body.clientWidth;
    const itemLeftPos = (boxRect && boxRect.left) || 0;
    const itemRightPos = screenWidth - ((boxRect && boxRect.right) || 0) - minPadding;
    const arearRequired = itemWidth + minPadding;
    return getPosition(position, arearRequired, itemLeftPos, itemRightPos);
};
export { identifyPosition };
